import React, { useEffect, useState } from "react";
import { api, formatDateTime } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Badge } from "../components/ui/badge";
import { Plus, Phone, Mail, MessageCircle, Users, Presentation, Trash2 } from "lucide-react";
import { toast } from "sonner";

const TYPE_ICON = { whatsapp: MessageCircle, email: Mail, call: Phone, meeting: Users, demo: Presentation, followup: Users, proposal: Mail, other: Users };
const empty = { type:"call", subject:"", company:"", date:"", result:"", next_action:"", notes:"" };

export default function Activities() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);

  const load = async () => { const r = await api.get("/activities"); setItems(r.data); };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/activities", { ...form, date: form.date || new Date().toISOString() });
      toast.success("Aktivitas dicatat"); setOpen(false); setForm(empty); load();
    } catch { toast.error("Gagal menyimpan"); }
  };
  const del = async (id) => { if(!window.confirm("Hapus?"))return; await api.delete(`/activities/${id}`); load(); };

  return (
    <div className="space-y-5" data-testid="activities-page">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold" style={{fontFamily:"Outfit"}}>Aktivitas</h1>
          <p className="text-sm text-slate-500">Timeline interaksi dengan kontak & deals.</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="brand-btn" data-testid="add-activity-btn"><Plus className="w-4 h-4 mr-1"/>Catat Aktivitas</Button></DialogTrigger>
          <DialogContent className="max-w-lg">
            <DialogHeader><DialogTitle>Aktivitas Baru</DialogTitle></DialogHeader>
            <div className="grid grid-cols-2 gap-3 py-2">
              <div><Label>Tipe</Label>
                <Select value={form.type} onValueChange={(v)=>setForm({...form,type:v})}>
                  <SelectTrigger><SelectValue/></SelectTrigger>
                  <SelectContent>{["whatsapp","email","call","meeting","demo","proposal","followup","other"].map(s=><SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                </Select>
              </div>
              <div><Label>Tanggal</Label><Input type="datetime-local" value={form.date} onChange={(e)=>setForm({...form,date:e.target.value})}/></div>
              <div className="col-span-2"><Label>Subjek</Label><Input data-testid="activity-subject" value={form.subject} onChange={(e)=>setForm({...form,subject:e.target.value})}/></div>
              <div className="col-span-2"><Label>Perusahaan</Label><Input value={form.company} onChange={(e)=>setForm({...form,company:e.target.value})}/></div>
              <div className="col-span-2"><Label>Hasil</Label><Input value={form.result} onChange={(e)=>setForm({...form,result:e.target.value})}/></div>
              <div className="col-span-2"><Label>Aksi Berikutnya</Label><Input value={form.next_action} onChange={(e)=>setForm({...form,next_action:e.target.value})}/></div>
            </div>
            <DialogFooter><Button variant="outline" onClick={()=>setOpen(false)}>Batal</Button><Button className="brand-btn" onClick={save} data-testid="activity-save">Simpan</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <Card className="p-4">
        <div className="space-y-3">
          {items.map((a)=>{
            const Icon = TYPE_ICON[a.type] || Users;
            return (
              <div key={a.id} className="flex items-start gap-3 p-3 rounded-lg hover:bg-slate-50 border-l-2 border-emerald-500" data-testid={`activity-row-${a.id}`}>
                <div className="w-9 h-9 rounded-full bg-emerald-50 flex items-center justify-center text-emerald-700"><Icon className="w-4 h-4"/></div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-slate-800">{a.subject}</span>
                    <Badge variant="outline" className="capitalize text-[10px]">{a.type}</Badge>
                  </div>
                  <div className="text-xs text-slate-500">{a.company} · {formatDateTime(a.date)}</div>
                  {a.result && <div className="text-xs text-slate-600 mt-1"><b>Hasil:</b> {a.result}</div>}
                  {a.next_action && <div className="text-xs text-emerald-700 mt-0.5"><b>Berikutnya:</b> {a.next_action}</div>}
                </div>
                <button onClick={()=>del(a.id)} className="text-slate-300 hover:text-rose-500"><Trash2 className="w-4 h-4"/></button>
              </div>
            );
          })}
          {items.length === 0 && <div className="text-center py-8 text-slate-500">Belum ada aktivitas.</div>}
        </div>
      </Card>
    </div>
  );
}
